var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Card',[_c('Tabs',{attrs:{"type":"card"}},[_c('TabPane',{attrs:{"closable":false,"label":"设备维修记录"}},[_c('repair')],1),_c('TabPane',{attrs:{"closable":false,"label":"设备保养记录"}},[_c('maintenance')],1)],1)],1)],1)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c6620620","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/report/devices/index.vue
// module id = null
// module chunks = 